"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EmployerDropdown = void 0;
var _react = _interopRequireDefault(require("react"));
var _Dropdown = require("../../../components/Dropdown");
var _endpoints = require("../../../utils/endpoints");
var _utils = require("../../../utils");
var _ = require("../..");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var EmployerDropdown = function EmployerDropdown(_ref) {
  var patient = _ref.patient,
    selectedRelation = _ref.selectedRelation,
    onUpdateSuccess = _ref.onUpdateSuccess;
  var _useRequest = (0, _utils.useRequest)((0, _endpoints.getEmployersUrl)()),
    _useRequest$data = _useRequest.data,
    employers = _useRequest$data === void 0 ? [] : _useRequest$data,
    employersLoading = _useRequest.loading;
  var _useRequest2 = (0, _utils.useRequest)(function (employerId) {
      return {
        url: (0, _endpoints.getPatientEmployerRelationsUrl)(),
        method: 'patch',
        data: {
          employerId: employerId,
          patientId: patient.id
        }
      };
    }, {
      manual: true,
      onSuccess: function onSuccess() {
        _utils.toast.success({
          title: 'Patient employer settings updated successfully.'
        });
        onUpdateSuccess();
      }
    }),
    updateEmployer = _useRequest2.run;
  var handleChange = function handleChange(value) {
    if ((selectedRelation === null || selectedRelation === void 0 ? void 0 : selectedRelation.employerId) !== value) {
      updateEmployer(value);
    }
  };
  if (employersLoading) {
    return /*#__PURE__*/_react.default.createElement(_.SpinPlaceholder, null);
  }
  return /*#__PURE__*/_react.default.createElement(_Dropdown.Dropdown, {
    className: "w-full mb-[15px]",
    placeholder: "No Employer",
    id: "Employer Dropdown",
    value: selectedRelation === null || selectedRelation === void 0 ? void 0 : selectedRelation.employerId,
    onChange: handleChange
  }, employers.map(function (option) {
    return /*#__PURE__*/_react.default.createElement(_Dropdown.Dropdown.Option, {
      value: option.id,
      key: option.id
    }, option.name);
  }));
};
exports.EmployerDropdown = EmployerDropdown;